import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { toastr } from "react-redux-toastr";
import TagPayDashboardComponent from "./component";

const TagPayDashboardContainer = (props) => {
  const { corporateId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [corporateName, setCorporateName] = useState("");
  const [pgid, setPgid] = useState(null);
  const [error, setError] = useState(null);
  const [accountType, setAccountType] = useState(null);
  const [selectedTagUid, setSelectedTagUid] = useState(null);

  // Get pgid and accountType from location state or URL params
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const urlPgid = searchParams.get('pgid');
    const urlAccountType = searchParams.get('accountType');
    
    if (location.state?.pgid) {
      setPgid(location.state.pgid);
    } else if (urlPgid) {
      setPgid(urlPgid);
    }
    
    // Prioritize accountType from state first, then URL params
    if (location.state?.accountType) {
      setAccountType(location.state.accountType);
    } else if (urlAccountType) {
      setAccountType(urlAccountType);
    }
    
    if (location.state?.corporateName) {
      setCorporateName(location.state.corporateName);
    }
    
    if (location.state?.tagUid) {
      setSelectedTagUid(location.state.tagUid);
    }
    
    console.log("TagPayDashboard - PGID:", pgid, "AccountType:", accountType);
  }, [location.state, location.search]);

  // Fetch dashboard data
  const fetchDashboardData = useCallback(() => {
    if (!corporateId) {
      setError("Corporate ID not found");
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    
    let url = `/partner/api/v2/corporates/${corporateId}/dashboard`;
    const params = new URLSearchParams();
    
    if (pgid) {
      params.append('pgid', pgid);
    }
    
    if (accountType) {
      params.append('account_type', accountType);
    }
    
    const queryString = params.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
    
    console.log("Fetching dashboard from:", url);
    
    props.getDataFromAPI(
      url,
      "GET",
      undefined,
      (response) => {
        console.log("Dashboard API Response:", response);
        if (response) {
          // Set accountType from response if not already set
          if (response.accountType && !accountType) {
            setAccountType(response.accountType);
          }
          setDashboardData(response);
        } else {
          setError("Failed to load dashboard data");
        }
        setLoading(false);
      },
      (error) => {
        console.error("Error fetching dashboard:", error);
        setError(error?.message || "Failed to fetch dashboard data");
        toastr.error("Error", "Unable to load dashboard data");
        setLoading(false);
      }
    );
  }, [corporateId, pgid, accountType, props]);

  useEffect(() => {
    if (corporateId) {
      fetchDashboardData();
    } else {
      setError("Corporate ID not found");
      setLoading(false);
    }
  }, [corporateId, fetchDashboardData]);

  // Navigation handlers with accountType in URL
  const handleAddTag = () => {
    const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";
    navigate(`/home/walletandtag/tagpymanagementv2/create-bulk-tag/${corporateId}/${pgid || '11'}?accountType=${finalAccountType}`);
  };

  const handleAddRule = () => {
    const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";
    navigate(`/home/customermanager/corporate/add-rule/${corporateId}?pgid=${pgid || '11'}&accountType=${finalAccountType}`);
  };

  const handleViewDepartments = () => {
    const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";
    navigate(`/home/customermanager/departments/${corporateId}?pgid=${pgid || '11'}&accountType=${finalAccountType}`);
  };

  const handleViewTag = () => {
    const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";
    navigate(`/home/walletandtag/tagpymanagementv2/view-tag/${corporateId}/${pgid || '11'}?accountType=${finalAccountType}`);
  };

  const handleViewRules = () => {
    const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";
    navigate(`/home/customermanager/corporate/rules/${corporateId}?pgid=${pgid || '11'}&accountType=${finalAccountType}`);
  };

  const handleViewUsageLimit = () => {
    const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";
    navigate(`/home/customermanager/usage-limit/${corporateId}?pgid=${pgid || '11'}&accountType=${finalAccountType}`);
  };

  const handleViewRechargeHistory = () => {
    const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";
    navigate(`/home/customermanager/recharge-history/${corporateId}?accountType=${finalAccountType}`);
  };

  const handleBackClick = () => {
    navigate(-1);
  };

  const handleRefresh = () => {
    fetchDashboardData();
  };

  // Get final accountType (prioritize from state, then from dashboard data)
  const finalAccountType = accountType || dashboardData?.accountType || "WALLET_RFID";

  return (
    <TagPayDashboardComponent
      corporateId={corporateId}
      corporateName={corporateName}
      dashboardData={dashboardData}
      loading={loading}
      error={error}
      accountType={finalAccountType}
      onAddTag={handleAddTag}
      onAddRule={handleAddRule}
      onViewDepartments={handleViewDepartments}
      onViewTags={handleViewTag}
      onViewRules={handleViewRules}
      onViewUsageLimit={handleViewUsageLimit}
      onViewRechargeHistory={handleViewRechargeHistory}
      onBackClick={handleBackClick}
      onRefresh={handleRefresh}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(TagPayDashboardContainer);